import { useMutation } from "@tanstack/react-query";

import { importGlobalScheduleRules } from "~/api/global-schedule-rules";
import { errorToast, toast } from "~/ui";

type UseImportGlobalScheduleRulesOptions = {
  onSuccess?: (imported: number) => void;
  onError?: (error: unknown) => void;
};

export const useImportGlobalScheduleRules = (
  options?: UseImportGlobalScheduleRulesOptions,
) => {
  return useMutation({
    mutationFn: (file: File) => importGlobalScheduleRules(file),
    onSuccess: (data) => {
      toast({
        type: "success",
        title: `${data.imported} rule(s) imported successfully`,
      });
      options?.onSuccess?.(data.imported);
    },
    onError: (error) => {
      if (options?.onError) {
        options.onError(error);
      } else {
        errorToast(error);
      }
    },
  });
};
